angular.module('LeasePilot').directive('unlockedVar', [
  '$filter',
  '$rootScope',
  '$sanitize',
  function($filter, $rootScope, $sanitize) {
    var generateLine = function(l) {
      if (l) {
        return new Array(l + 1).join('_');
      } else {
        return '__________';
      }
    };
    
    const unlockedVarLink = function(scope, element, attrs) {
      const appScope = $rootScope.findAppScope();

      // Disable editing 'building-variable' in admin mode
      scope.disable = function() {
        element.attr('contenteditable', false);
        element.attr('title', "Building Language can't be edited");
      };
    
      scope.enable = function() {
        element.attr('contenteditable', true);
        element.attr('title', '');
        element.addClass('editable');
      };
    
      $rootScope.adminMode || ($rootScope.lease && $rootScope.lease.isLocked)
        ? scope.disable()
        : scope.enable();
    
      scope.$watch('[name, calc]', function(newval) {
        if (attrs.name === "building.name") {
          if (appScope.lease?.building?.displayName) {
            newval[0] = appScope.lease.building.displayName;
          }
        }
        
        if (
          (attrs["calc"] &&
            scope.calc !== null &&
            scope.calc !== undefined &&
            scope.calc !== "" &&
            scope.calc !== Infinity &&
            scope.calc !== "NaN" &&
            !Number.isNaN(scope.calc)) ||
          (!attrs["calc"] &&
            newval[0] !== null &&
            newval[0] !== undefined &&
            newval[0] !== "" &&
            newval[0] !== Infinity &&
            !Number.isNaN(newval[0]))
        ) {
          var processedVal = attrs["calc"] ? scope.calc : newval[0];
          
          if (scope.f1) {
            processedVal = $filter(scope.f1)(processedVal, scope.f1Options);
          }
          if (scope.f2) {
            processedVal = $filter(scope.f2)(processedVal, scope.f2Options);
          }
          if (scope.f3) {
            processedVal = $filter(scope.f3)(processedVal, scope.f3Options);
          }

          try {
            processedVal = $sanitize(processedVal);
          } catch (ex) {
            processedVal = "";
          }

          element.html(
            "<span lease-section='" +
              scope.inputLs +
              "'>" +
              processedVal +
              '</span>',
          );
        } else if (scope.ev) {
          element.html('<span>' + scope.ev + '</span>');
        } else {
          element.html('<span>' + generateLine(scope.ll) + '</span>');
        }
      });
    
      $rootScope.$on('leaseStatusChanged', function(event, status) {
        if (status.lock) {
          scope.disable();
        } else {
          scope.enable();
        }
      });
    };
    
    return {
      restrict: 'E',
      scope: {
        inputLs: '@',
        ll: '=',
        ev: '@',
        name: '=',
        calc: '=',
        f1: '@',
        f1Options: '@',
        f2: '@',
        f2Options: '@',
        f3: '@',
        f3Options: '@',
      },
      link: unlockedVarLink,
    };
  },
]);
